import React, { useState, useEffect } from "react";
import { getAllActions } from "../../../services/tenant/actionsType";
// import ModuleAccessSelector from "./ModuleAccess";
import { getAllModulesAdmin } from "../../../services/tenant/tenant";
import { toast } from "../../../components/AppToast";
import { useSelector } from "react-redux";
// import { moduleTypeEnum } from "../../../utils/enumGlobalOptionData";
import RoleAccessSelectorAdmin from "./ModuleAccessAdmin";

const RoleFormAdmin = ({
  initialValues = {},
  onSubmit = () => { },
  submitText = "Save",
  cancelText = "",
  onCancel = () => { },
  readOnly = false,
  partners
}) => {
  const { userDetail } = useSelector((state) => state.login);
  const [formData, setFormData] = useState({});
  const [accessState, setAccessState] = useState({});
  const [modulesData, setModulesData] = useState([]);
  const [accessTypes, setAccessTypes] = useState([]);
  const [partnersOptions, setPartnersOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const { tenantId } = useSelector((state) => state?.login?.userDetail);

  console.log(userDetail,"userDetail");
  const roleTypeOptions =
  userDetail?.userType === 'PARTNER'
    ? [{ label: "External", value: "EXTERNAL" }]
    : [
        { label: "Internal", value: "INTERNAL" },
        { label: "External", value: "EXTERNAL" },
      ];
  // ------------------ Fields ------------------
  const roleFields = [
    { name: "roleID", label: "Role ID", required: true },
    { name: "roleDescription", label: "Role Description", required: true },
    {
      name: "roleType",
      label: "Role Type",
      type: "select",
      options: roleTypeOptions,
      required: true,
    },
    {
      name: "roleOrganization",
      label: "Role Organization",
      type: "select",
      options: partnersOptions,
      required: false,
      isDisabled: true,
      conditional: (formData) => formData?.roleType !== "",
    },
  ];

  // ------------------ Setup ------------------
  const getPartnersOptions = (data) => {
    if (formData?.roleType !== "EXTERNAL") {
      setPartnersOptions([{ label: tenantId?.tenant_name, value: tenantId?._id }]);
    } else {
      setPartnersOptions(data || []);
    }
  };

  useEffect(() => {
    getPartnersOptions(partners);
  }, [formData?.roleType]);

  useEffect(() => {
    setFormData(
      roleFields.reduce((acc, field) => {
        if (field.name === "roleOrganization") {
          if (initialValues.roleType === "EXTERNAL" && initialValues.partnerId) {
            return { ...acc, [field.name]: initialValues.partnerId._id || "" };
          }
          if (initialValues.roleType === "INTERNAL") {
            return { ...acc, [field.name]: initialValues?.tenantId?._id };
          }
        }
        return {
          ...acc,
          [field.name]: initialValues[field.name] ?? "",
        };
      }, {})
    );
  }, []);

  // ------------------ Change ------------------
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "roleType") {
      if (value === "EXTERNAL" && partners.length === 0) {
        toast.error("No partner onboarded, please add partner first.");
        setFormData((prev) => ({ ...prev, [name]: "" }));
        return;
      }

      if (value === "INTERNAL") {
        setFormData({
          ...formData,
          [name]: value,
          roleOrganization: tenantId?._id,
        });
      } else {
        setFormData({
          ...formData,
          [name]: value,
          roleOrganization: "",
        });
      }

      setErrors((prev) => ({ ...prev, [name]: "" }));
      return;
    }

    setFormData({ ...formData, [name]: value });
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // ------------------ Validation ------------------
  const validate = () => {
    const newErrors = {};

    // field-level validation
    roleFields.forEach((field) => {
      if (
        field.required &&
        (!formData[field.name] || formData[field.name].toString().trim() === "")
      ) {
        newErrors[field.name] = `${field.label} is required`;
      }
    });

    // module access validation
    const hasAccessSelected = convertAccessObject(accessState);

    if (!hasAccessSelected.length) {
      newErrors.moduleAccess = "Please select at least one module access";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const convertAccessObject = (input) => {
    return Object.entries(input).map(([moduleId, childrenObj]) => ({
      moduleId,
      children: Object.entries(childrenObj).map(([id, actions]) => ({
        id,
        actions
      }))
    }));
  };

  // ------------------ Submit ------------------
  const handleSubmit = (e) => {
    e.preventDefault();

    const permissions = convertAccessObject(accessState);

    if (!validate()) return;



    const payloadTenId =
      formData.roleType === "INTERNAL";

    const payload = {
      ...payloadTenId,
      roleDescription: formData.roleDescription,
      roleID: formData.roleID,
      roleType: formData.roleType,
      permissions: permissions,
    };

    onSubmit(payload, initialValues._id);
  };



  const toInitialAccess = (arr) => {
  const obj = {};
  arr.forEach(({ moduleId, children }) => {
    obj[moduleId] = {};
    children.forEach(({ id, actions }) => {
      obj[moduleId][id] = actions;
    });
  });
  return obj;
};


  // ------------------ Load Data ------------------
  useEffect(() => {
    const permissions = initialValues?.permissions || [];

    const formattedInitialAccess = toInitialAccess(permissions);

    setAccessState(formattedInitialAccess);

    const fetchMenu = async () => {
      try {
        const menuData = await getAllModulesAdmin();
        const actionData = await getAllActions();
        setModulesData(menuData || []);
        setAccessTypes(actionData || []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchMenu();
  }, [initialValues?.permissions?.allow]);

  // ------------------ JSX ------------------
  return (
    <form onSubmit={handleSubmit}>
      <div className="row gx-3 gy-3">
        {roleFields.map((field) => {
          if (field.conditional && !field.conditional(formData)) return null;

          const isDisabled =
            readOnly ||
            ["roleID", "roleDescription", "roleType", "roleOrganization"].includes(
              field.name
            );

          return (
            <div className="col-md-3" key={field.name}>
              <label className="form-label fw-semibold small">
                {field.label} {field.required && <span className="text-danger">*</span>}
              </label>

              {field.type === "select" ? (
                <select
                  className={`form-select form-select-sm ${errors[field.name] ? "is-invalid" : ""}`}
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                  disabled={isDisabled}
                >
                  <option value="">Select {field.label}</option>
                  {field.options.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={field.type || "text"}
                  className={`form-control form-control-sm ${errors[field.name] ? "is-invalid" : ""}`}
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                  disabled={isDisabled}
                />
              )}
              {errors[field.name] && (
                <small className="text-danger">{errors[field.name]}</small>
              )}
            </div>
          );
        })}
      </div>

      {/* Module Access */}
      <div className="mt-4">
        <p className="form-label fw-semibold">Module Access</p>
        <RoleAccessSelectorAdmin
          modulesData={modulesData}
          accessTypes={accessTypes}
          initialAccess={accessState}
          onChange={setAccessState}
          readOnly={readOnly}
        />
        {errors.moduleAccess && (
          <small className="text-danger">{errors.moduleAccess}</small>
        )}
      </div>

      {/* Buttons */}
      <div className="text-end mt-4 d-flex justify-content-center mt-5">
        {readOnly ? (
          <div className="ms-2">
            <button onClick={() => onCancel({})} className="btn btn-secondary px-5">
              Back
            </button>
          </div>
        ) : (
          <>
            {cancelText && (
              <div className="ms-2">
                <button onClick={() => onCancel({})} className="btn btn-secondary px-5">
                  {cancelText}
                </button>
              </div>
            )}
            <div className="ms-2">
              <button type="submit" className="btn btn-primary px-5">
                {submitText}
              </button>
            </div>
          </>
        )}
      </div>
    </form>
  );
};

export default RoleFormAdmin;
